export function turkishToLower(string) {
  var letters = { İ: 'i', I: 'ı', Ş: 'ş', Ğ: 'ğ', Ü: 'ü', Ö: 'ö', Ç: 'ç' };
  string = string.replace(/(([İIŞĞÜÇÖ]))+/g, function(letter) {
    return letters[letter];
  });
  return string.toLowerCase();
}
